import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {TextField, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import {MetaTags} from 'react-meta-tags';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import axios from 'axios';
import Cookies from 'js-cookie';
import Tooltip from '@mui/material/Tooltip';
import CategorySave from './CategorySave';
import DialogAuthorization from '../components/DialogAuthorization';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import Header from "../pages/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  var vertical='top',horizontal='center';
  
  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isBlogAdminLoggedIn');
	const childRefNewSave = React.useRef();
	const childRefAuthorization = React.useRef();
	const [pageLoading, setPageLoading] = React.useState(true);
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [authPrivileges, setAuthPrivileges] = React.useState({});
	
	const [delBtn, setDelBtn] = React.useState(false);
	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
  
	const [channelId, setChannelId] = React.useState(0);
	const [channelList, setChannelList] = React.useState([]);

	var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
    myPastFromDate.setDate(myPastFromDate.getDate() - 366);

	function hideAlert(){
		setShowAlert(false);
	}

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'id', headerName: 'Sr. No.', width: 40 },
		{ field: 'categoryName', headerName: 'Category Name', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'categoryUrl', headerName: 'Category URL', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },   
	    { field: 'parentCategoryName', headerName: 'Parent Category Name', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'channelName', headerName: 'Channel Name', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'publicDisplay', headerName: 'Public', width: 90, renderCell: (params) =>  (
			<span>{params.value===1?<>Show</>:<>Hidden</>}</span>
		   ), },
		{ field: 'homeDisplay', headerName: 'Home', width: 90, renderCell: (params) =>  (
			<span>{params.value===1?<>Show</>:<>Hidden</>}</span>
		   ), },  
		{ field: 'headerDisplay', headerName: 'Header', width: 90, renderCell: (params) =>  (
			<span>{params.value===1?<>Show</>:<>Hidden</>}</span>
		   ), },
		{ field: 'footerDisplay', headerName: 'Footer', width: 90, renderCell: (params) =>  (
			<span>{params.value===1?<>Show</>:<>Hidden</>}</span>
		   ), }, 
		{ field: 'sideDisplay', headerName: 'Side', width: 90, renderCell: (params) =>  (
			<span>{params.value===1?<>Show</>:<>Hidden</>}</span>
		   ), },         		   
		{ field: 'modifiedBy', headerName: 'Modified By', width: 110, renderCell: (obj) =>  (
			<span>{obj.row.modifiedBy} {obj.row.modifiedDateTime}</span>
		   ), },
	    { field: 'createdBy', headerName: 'Created By', width: 110, renderCell: (obj) =>  (
			<span>{obj.row.createdBy} {obj.row.createdDateTime}</span>
		   ), } ,
   
	  ];
	

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(userObj?.obj && userObj?.obj?.loginId && userObj?.obj?.token){
			getApiData(userObj?.obj?.loginId, userObj?.obj?.token);
		}
	}, [userObj,filter]);

	async function getApiData(loginId,token){
		let axiosHeader = {
			headers:{
			  'Content-Type': 'multipart/mixed',
			  'loginId': loginId,
			  'token': token,
			  'device': 'web'
			}
		  }; 
			axios.get(env.API_URL+'/admin/category-list?keyword='+keyword+'&channelId='+channelId, axiosHeader)
			   .then(response => {
			 	////document.write("Just Checking >> "+JSON.stringify(response.data)); 
				 setPageLoading(false);
				 if(response.data && response.data.responseTxt==="InvalidToken"){ 
					Cookies.remove('isBlogAdminLoggedIn');
					window.location.href='login';
				 }else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					 childRefAuthorization.current.handleClickOpen();
				 }else if(response.data.responseTxt==="success"){
					if(response.data?.obj){					 
					  setRows(response.data.obj);
					}  
					  setAuthPrivileges(response.data.privileges);
				 }	 				
			})
	}

	function deleteData(){
		if(dataObj && userObj?.obj && userObj?.obj?.loginId && userObj?.obj?.token){
			let axiosHeader = {
				headers:{
				  'Content-Type': 'multipart/mixed',
				  'loginId': userObj?.obj?.loginId,
				  'token': userObj?.obj?.token,
				  'device': 'web'
				}
			  }; 
	
		  const data = new FormData();
		  data.append('id', dataObj.autoId);
				 
		  setDelBtn(true);
		  axios.post(env.API_URL+'/admin/category-delete', data, axiosHeader)
				.then((response) => {
					setDelBtn(false);
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Category has been deleted.");
			  		search();	
					deleteDialogHide();
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This category could not be deleted.");			
					return false;
				}
			})
				.catch((error) => {
					console.log("AXIOS ERROR: ", error);
				})	
		}		
	
		
	}


	React.useEffect(() => {		
		if(userObj?.obj && userObj?.obj?.loginId && userObj?.obj?.token){
			getApiDataChannels(userObj?.obj?.loginId, userObj?.obj?.token);
		}
	}, [userObj]);

	async function getApiDataChannels(loginId,token){
		let axiosHeader = {
			headers:{
			  'Content-Type': 'multipart/mixed',
			  'loginId': loginId,
			  'token': token,
			  'device': 'web'
			}
		  }; 
			axios.get(env.API_URL+'/admin/channel-list?sortBy=channelName', axiosHeader)
			   .then(response => {
			 	////document.write("Just Checking >> "+JSON.stringify(response.data)); 
				 setPageLoading(false);
				 if(response.data && response.data.responseTxt==="InvalidToken"){ 
					Cookies.remove('isBlogAdminLoggedIn');
					window.location.href='login';
				 }else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					 childRefAuthorization.current.handleClickOpen();
				 }else if(response.data.responseTxt==="success"){
					if(response.data?.obj){					 
					  setChannelList(response.data.obj);
					} 
				 }	 				
			})
	}


	function saveData(opt){
		if(opt===1){
			setDataObj(null);
		}	
		childRefNewSave.current.handleClickOpen();
	}

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
			///childRef.current.handleClickOpen();
		}
	}

	function search(){
		setSelectedRow(0);
		setDataObj({});
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function handleChannel(id){
		setChannelId(id);
		search();
	}

	return (
		<div> 
				<MetaTags>
            		<title>Category List</title>
          		</MetaTags>
				
				<Header title="Category List" />
				{pageLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<FormControl variant="outlined" size='small' style={{float:'left',width:150,marginRight:6}}>
										<Select 
											style={{width:'100%'}}
											///classes={{ paper: classes.paper }}
											labelId="select-class-labela"
											id="select-classa"
											value={channelId}									
											onChange={event => handleChannel(event.target.value)}											
											>
												<MenuItem value={0} >{channelId?<>Deselect</>:<>Select</>} Channel</MenuItem> 
												{(channelList && channelList.length>0)?
												channelList.map((myRow,key)=>(
													<MenuItem key={'mtk'+key} value={myRow.autoId} >{myRow.channelName}</MenuItem> 
												)):null}
										</Select>
									</FormControl>
									<FormControl style={{float:'left',width:150,marginRight:60}}>
										<TextField
										id="keywordtxt"
										label="Search"
										defaultValue={keyword}
										sx={{ width: 200 }}
										size="small"
										onChange={event => setKeyword(event.target.value)}
										onKeyPress={(event)=>{onEnter(event)}}
										/>
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop: -3}} size="small" variant="contained" color="secondary" >Search</Button>

									<span style={{marginTop:30}}>
											{(authPrivileges && authPrivileges.create===1)?	
												<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}
										{selectedRow>0?<>
											{(authPrivileges && authPrivileges.update===1)?
												<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}
											{(authPrivileges && authPrivileges.delete===1)?
												<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash" style={{fontSize:25, color:'#0158dc',marginLeft:15, cursor:'pointer'}} />
											:null}	
										</>:null}
									</span>	
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '82vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={50}
							rowHeight={40}
							rowsPerPageOptions={[50]}
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No rows found!</span>
								  </Stack>
								)}}	
							onRowClick={itm => selectRow(itm)}	
						/>
					</div>

				</Box>

			<CategorySave dataObj={dataObj} channelList={channelList} ref={childRefNewSave} />						
			
			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					{delBtn?                
						<LoadingButton loading loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#ff0000',color:'#FFF',marginRight:10}} size="small" variant="outlined" >Deleting...</LoadingButton>
						:<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
                    }
					</DialogActions>
				</Dialog>

			    <DialogAuthorization ref={childRefAuthorization} />

		</div>	
	);
  }